import angular from 'angular';
import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	if ($scope.options && $scope.options.building) {
		return;
	}

	const temporaryOptions = angular.copy($scope.component.options);

	$scope.$watch('component.options.name', (/** @type {any} */ newName, /** @type {any} */ oldName) => {
		if (newName !== oldName && angular.isString(newName) && newName.trim() === '') {
			$scope.component.options.name = undefined;
		}
	});
	$scope.$watch('readOnly', () => {
		if ($scope.readOnly === true) {
			$scope.component.options.mode = 'view';
			$scope.component.options.modes = [];
		}
		else {
			$scope.component.options.mode = temporaryOptions.mode;
			$scope.component.options.modes = temporaryOptions.modes;
		}
	});

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
};
